module.exports = __webpack_public_path__ + "static/media/Q3Mob.d7da4248.png";